import React, { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { ConfigProvider, Modal as AntdModal, ModalProps as AntdModalProps } from 'antd';
import { IoIosClose } from 'react-icons/io';

interface ModalProps extends AntdModalProps {
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export const Modal: FC<ModalProps> = (props) => {
    useEffect(() => {
        if (props.open) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    }, [props.open]);

    return (
        <ConfigProvider theme={{
            components: {
                Modal: {
                    titleFontSize: 20,
                },
            },
            token: {
                borderRadius: 16,
                padding: 24,
            },
        }}>
            <AntdModal
                {...props}
                styles={{
                    content: {
                        border: '1px solid #D2DEFE',
                    },
                }}
                maskClosable
                mask
                destroyOnClose
                centered
                footer={null}
                onCancel={() => props.setOpen(false)}
                closeIcon={<div className={'w-5 h-5 flex items-center justify-center border border-black-100 rounded-[4px]'}><IoIosClose color={"black"} /></div>}
            />
        </ConfigProvider>
    );
};